import Link from "next/link";
import { FunctionComponent } from "react";
import { ButtonType } from "types";

const Button: FunctionComponent<ButtonType> = (props) => {
  let btnClass: string = "button";

  props.btnClass.split(",").map((value) => (btnClass += ` button--${value.trim()}`));

  if (props.linkType == "exlink") {
    // external links
    return (
      <a id={props.id} href={props.btnHref} className={btnClass} aria-label={props.ariaLabel}>
        {props.children}
      </a>
    );
  } else if (props.linkType == "link" && props.btnHref) {
    // internal links
    return (
      <Link href={props.btnHref}>
        <a id={props.id} aria-label={props.ariaLabel} className={btnClass}>
          {props.children}
        </a>
      </Link>
    );
  } else {
    // normal button
    return (
      <button
        id={props.id}
        className={btnClass}
        type={props.btnType}
        onClick={props.btnClick}
        aria-label={props.ariaLabel}
        disabled={props.disabled}
      >
        {props.children}
      </button>
    );
  }
};

export default Button;
